import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { format } from "date-fns";
import { getErrorsMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
class FileCommentsInternal extends Component {
    constructor(props) {
        super();
        this.state = {
            comment: '',
            comments: [],
        };
        this.save = this.save.bind(this);
        this.handleCommentChange = this.handleCommentChange.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.delete = this.delete.bind(this);
    }

    componentDidMount() {
        this.getComments()

        FormValidation.formValidation(KTUtil.getById('frm'), {
            fields: {
                comment: {
                    validators: {
                        notEmpty: {
                            message: 'Comentario requerido'
                        },
                        stringLength: {
                            min: 4,
                            max: 800,
                            message: 'El comentario debe tener una longitud mínima de 4'
                        },
                    }
                },
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                submitButton: new FormValidation.plugins.SubmitButton(),
                bootstrap: new FormValidation.plugins.Bootstrap({
                    eleInvalidClass: '',
                    eleValidClass: '',
                })
            },
        }).on('core.form.valid', () => {
            this.save();
        });
    }

    async getComments(){
        const res = await axios.get('/api/documents/' + this.props.document_id + '/comments')
        const data = res.data
        this.setState({comments: data})
    }

    handleCommentChange(e) {
        this.setState({ comment: e.target.value });
    }

    async save() {
        window.blockUI();
        KTUtil.btnWait(KTUtil.getById('btnSend'), 'spinner spinner-right spinner-white pr-15', "Procesando...");

        const params = JSON.stringify({
            comment: this.state.comment
        });

        await axios.post(
            '/api/documents/' + this.props.document_id + '/comments',
            params,
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            window.unblockUI();
            KTUtil.btnRelease(KTUtil.getById('btnSend'));
            this.getComments();
            this.setState({ comment: "" });

            swal.fire({
                text: "Guardado",
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            });
        })
        .catch((error) => {
            window.unblockUI();
            const message = getErrorsMessage(error);

            KTUtil.btnRelease(KTUtil.getById('btnSend'));

            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            }).then(function() {
                KTUtil.scrollTop();
            });
        });
    }

    confirmDelete(id) {
        swal.fire({
            text: "¿Desea continuar con la eliminación?",
            showCancelButton: true,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Continuar",
            cancelButtonText: "Cancelar",
            customClass: {
                confirmButton: "btn font-weight-bold btn-primary",
                cancelButton: "btn font-weight-bold btn-danger"
            }
        }).then((result) => {
            if (result.isConfirmed) {
                this.delete(id);
            }
        });
    }

    async delete(id) {
        window.blockUI();
        await axios.delete(
            '/api/documents/comments/' + id,
            {},
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            window.unblockUI();
            this.getComments();
        })
        .catch((error) => {
            window.unblockUI();
            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            }).then(function() {
                KTUtil.scrollTop();
            });
        });
    }

    render() {
        return (
            <div className="card card-custom gutter-b">
                <div className="card-body">
                    <h5 className="text-dark font-weight-bold my-1 mb-10">
                        Comentarios
                        <br/>
                        <small className="text-muted font-weight-bold">Dar de alta un comentario</small>
                    </h5>
                    { (this.props.permissions.documents_actions_internal.includes('all') || this.props.permissions.documents_actions_internal.includes('comment') ) &&
                    <form id="frm">
                        <div className="form-group">
                            <label>Nuevo Comentario</label>
                            <textarea rows="4" id="comment" name="comment" className="form-control form-control-solid" value={this.state.comment} onChange={this.handleCommentChange}></textarea>
                        </div>
                        <div className="form-group text-right">
                            <button id="btnSend" type="submit" className="btn btn-primary ml-4">
                                Enviar
                            </button>
                        </div>
                    </form>
                    }
                    <br/>

                    {this.state.comments.map((c, i) => {
                        return <div key={i} className="form-group">
                            <div>
                                <strong className="mr-4">{c.person.name}</strong> <small>{ format(new Date(c.created_at), 'dd/MM/yyyy') }</small>
                            </div>
                            <div className="text-muted">
                                {c.comment}
                                <button type="button" className="ml-5 btn btn-sm btn-link-danger" onClick={() => this.confirmDelete(c.id)}>
                                    Eliminar
                                </button>
                            </div>
                        </div>
                    })}
                </div>
            </div>
        );
    }
}

export default FileCommentsInternal;

if (document.getElementById('FileCommentsInternal')) {
    ReactDOM.render(<FileCommentsInternal />, document.getElementById('FileCommentsInternal'));
}
